export default "__VITE_ASSET__DSO1Q3e5__"